import React from 'react';
import { Popover } from '../index';

/**
 * Renders a set of action buttons, each wrapped in a Popover with a tooltip.
 *
 * @component
 * @param {Object} props
 * @param {Array<Object>} props.actions - Array of action objects to render as buttons.
 * @param {React.ReactNode} props.actions[].icon - The icon or content to display inside the button.
 * @param {string} props.actions[].className - CSS class for styling the button.
 * @param {function} props.actions[].onClick - Click handler for the button.
 * @param {boolean} [props.actions[].disabled] - Whether the button is disabled.
 * @param {React.ReactNode|string} props.actions[].tooltip - Tooltip content for the Popover.
 * @returns {JSX.Element} The rendered action buttons.
 */
const ActionButtons = ({ actions }) => {
  return (
    <div className="">
      {actions.map((action, index) => (
        <>
          <Popover key={index} content={action.tooltip} position="left-top">
            <button
              className={action.className}
              onClick={action.onClick}
              disabled={action.disabled}
            >
              {action.icon}
            </button>
          </Popover>
        </>
      ))}
    </div>
  );
};

export default ActionButtons;
